import { t } from 'utilities/TranslationUtils';

interface ChartOption<K extends string> {
  key: K;
  labelKey: string;
}

interface Props<K extends string> {
  options: ReadonlyArray<ChartOption<K>>;
  active: K;
  /** Charts shown by the other card: not selectable here. */
  disabledKeys?: ReadonlyArray<K>;
  onSelect: (key: K) => void;
  slot: number;
  /** Rendered at the end of the switcher row (add / remove chart). */
  action?: React.ReactNode;
  children: React.ReactNode;
}

/** A card that shows one chart and carries the pills to swap it for another, inside the card itself. */
export default function ChartSwitcherCard<K extends string>({ options, active, disabledKeys = [], onSelect, slot, action, children }: Props<K>) {
  return (
    <div className='pp-section pp-chart-slot' data-test={`pp-chart-slot-${slot}`}>
      <div className='pp-chart-slot__bar' role='tablist'>
        {options.map(({ key, labelKey }) => (
          <button
            key={key}
            type='button'
            role='tab'
            aria-selected={active === key}
            disabled={disabledKeys.includes(key)}
            className={`pp-chart-slot__pill${active === key ? ' pp-chart-slot__pill--active' : ''}`}
            onClick={() => onSelect(key)}
            data-test={`pp-chart-slot-${slot}-${key}`}
          >
            {t(labelKey)}
          </button>
        ))}
        {action && <span className='pp-chart-slot__action'>{action}</span>}
      </div>
      <div className='pp-chart-slot__body'>{children}</div>
    </div>
  );
}
